module.exports = __webpack_public_path__ + "img/scene2copy03.9b24d3eb.png";